jQuery(document).ready(function($) {

  // 👉 DEFINE FIRST
  var $progressBar = $(".slider-progress .progress-bar");

  function updateProgress(event) {
    if (!event.item) return;

    var total = event.item.count;
    var current = event.relatedTarget.relative(event.item.index);

    var progress = (current / (total - 1)) * 100;

    $progressBar.css("width", progress + "%");
  }

  $('#collection-slider').owlCarousel({
    loop: true,
    margin: 30,
    nav: true,
    dots: false,
    responsive: {
      0: { items: 1 },
      600: { items: 3 },
      1000: { items: 5 }
    },
    onInitialized: updateProgress,
    onTranslated: updateProgress
  });

  $('#brand_img_slider').owlCarousel({
    loop: true,
    margin: 30,
    nav: false,
    dots: false,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    responsive: {
      0: { items: 2 },
      600: { items: 4 },
      1000: { items: 6 }
    }
  });

  setTimeout(function() {
    $('#collection-slider').trigger('next.owl.carousel');
  }, 2000);

  setTimeout(function() {
    $('#brand_img_slider').trigger('next.owl.carousel');
  }, 2000);

});

// CUSTOM: Disabled submenu-open behavior on mobile for accordion menu
document.addEventListener("DOMContentLoaded", () => {

  if (window.innerWidth <= 1024) {

    const drawer = document.querySelector('menu-drawer, header-drawer');

    if (!drawer) return;

    drawer.querySelectorAll('summary').forEach(summary => {

      summary.addEventListener('click', function(e) {

        const details = this.closest('details');

        // Let native accordion work
        if (details && details !== drawer.querySelector('details')) {
          e.stopImmediatePropagation();
        }

      }, true); // 👈 use capture phase to override Shopify

    });

  }

});

// Product Vendor Name
document.addEventListener("DOMContentLoaded", function () {

  const vendorCache = {};
  const inFlightRequests = {};

  function processCards() {

    const cards = document.querySelectorAll('.boost-sd__product-item');

    cards.forEach(card => {

      
      if (card.querySelector('.custom-product-vendor')) return;

      const data = card.getAttribute('data-product');
      if (!data) return;

      let parsed;
      try {
        parsed = JSON.parse(data.replace(/&quot;/g, '"'));
      } catch (e) {
        console.log('JSON parse error', e);
        return;
      }

      const handle = parsed.handle;
      if (!handle) return;

      // ✅ If cached → use immediately
      if (vendorCache[handle]) {
        insertVendor(card, vendorCache[handle]);
        return;
      }

      // ✅ If already fetching → skip
      if (inFlightRequests[handle]) return;

      inFlightRequests[handle] = true;

      fetch(`/products/${handle}.js`)
        .then(res => res.json())
        .then(product => {

          if (!product || !product.vendor) return;

          vendorCache[handle] = product.vendor;

          // Apply vendor to ALL matching cards
          document.querySelectorAll('.boost-sd__product-item').forEach(c => {

            if (c.querySelector('.custom-product-vendor')) return;

            const d = c.getAttribute('data-product');
            if (!d) return;

            try {
              const p = JSON.parse(d.replace(/&quot;/g, '"'));

              if (p.handle === handle) {
                insertVendor(c, product.vendor);
              }

            } catch (e) {}

          });

        })
        .catch(err => console.log('Fetch error:', err));

    });
  }

  function insertVendor(card, vendor) {
    const title = card.querySelector('.boost-sd__product-title');
    if (!title) return;

    const div = document.createElement('div');
    div.className = 'custom-product-vendor';
    div.textContent = vendor;

    title.parentNode.insertBefore(div, title);
  }

  // ⏳ Initial delay (Boost renders async)
  setTimeout(processCards, 1200);

  // 🔁 Re-run after Boost updates
  ['boost:loaded', 'boost:filter', 'boost:search'].forEach(event => {
    document.addEventListener(event, () => {
      setTimeout(processCards, 400);
    });
  });

});

window.addEventListener("load", function () {

  var $slider = $('.handpicked-grid');

function initSlider() {
  if (window.innerWidth < 768) {

    if (!$slider.hasClass('owl-loaded')) {
      $slider.owlCarousel({
        items: 1.2,
        margin: 20,
        loop: true,
        dots: false,
        nav: false,
        stagePadding: 20,
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        smartSpeed: 800
      });

      // Scoped arrows
      $('.handpicked-section .next').click(function() {
        $slider.trigger('next.owl.carousel');
      });

      $('.handpicked-section .prev').click(function() {
        $slider.trigger('prev.owl.carousel');
      });

      // Scoped progress
      $slider.on('changed.owl.carousel', function(event) {
        var total = event.item.count;
        var index = event.item.index % total;
        var progress = ((index + 1) / total) * 100;

        $(this).closest('.handpicked-section')
          .find('.progress')
          .css('width', progress + '%');
      });
    }

  } else {
    if ($slider.hasClass('owl-loaded')) {
      $slider.owlCarousel('destroy');
    }
  }
}

initSlider();
window.addEventListener('resize', initSlider);

});

document.addEventListener("DOMContentLoaded", function () {

  let timeout;

  function applyCustomUI() {

    // =====================================================
    // CHANGE "REFINE BY" TO "FILTER"
    // =====================================================

    document.querySelectorAll(
      ".boost-sd__filter-tree-toggle-button-title--refine-by, .boost-sd__filter-option-title"
    ).forEach((element) => {

      const text = element.textContent.trim().toLowerCase();

      if (text.includes("refine")) {
        element.textContent = "Filter";
      }

    });

    // =====================================================
    // CHANGE "SHOW RESULT" TO "VIEW PRODUCTS"
    // =====================================================

    document.querySelectorAll(
      ".boost-sd__button--result .boost-sd__button-text"
    ).forEach((element) => {

      const countMatch = element.textContent.match(/\(.*\)/);

      const countText = countMatch ? ` ${countMatch[0]}` : "";

      element.textContent = "View products" + countText;

    });

    // // =====================================================
    // // CUSTOM CLEAR FILTER BUTTON
    // // =====================================================

    // document.querySelectorAll(".boost-sd__button--result")
    //   .forEach((resultBtn) => {

    //     // REMOVE OLD BUTTON
    //     const existingWrapper = resultBtn.parentElement.parentElement.querySelector(
    //       ".custom-clear-wrapper"
    //     );

    //     if (existingWrapper) {
    //       existingWrapper.remove();
    //     }

    //     // CREATE BUTTON
    //     const customBtn = document.createElement("button");

    //     customBtn.type = "button";

    //     customBtn.className =
    //       "boost-sd__button boost-sd__button--clear custom-clear-filters";

    //     customBtn.textContent = "Clear Filters";

    //     // CLICK EVENT
    //     customBtn.addEventListener("click", function (e) {

    //       e.preventDefault();
    //       e.stopPropagation();

    //       const clearBtn = document.querySelector(
    //         "#boost-sd__button-toolbar-mobile-clear, .boost-sd__button-clear-all-filter"
    //       );

    //       if (!clearBtn) return;

    //       // POINTERDOWN
    //       clearBtn.dispatchEvent(
    //         new PointerEvent("pointerdown", {
    //           bubbles: true,
    //           cancelable: true
    //         })
    //       );

    //       // MOUSEDOWN
    //       clearBtn.dispatchEvent(
    //         new MouseEvent("mousedown", {
    //           bubbles: true,
    //           cancelable: true
    //         })
    //       );

    //       // CLICK
    //       clearBtn.dispatchEvent(
    //         new MouseEvent("click", {
    //           bubbles: true,
    //           cancelable: true,
    //           view: window
    //         })
    //       );

    //     });

    //     // CREATE WRAPPER
    //     const wrapper = document.createElement("div");

    //     wrapper.className = "custom-clear-wrapper";

    //     wrapper.appendChild(customBtn);

    //     // INSERT BELOW VIEW PRODUCTS
    //     resultBtn.parentElement.insertAdjacentElement(
    //       "afterend",
    //       wrapper
    //     );

    //   });

    
  }

  // =====================================================
  // OBSERVE BOOST FILTER RERENDERS
  // =====================================================

  const observer = new MutationObserver(() => {

    clearTimeout(timeout);

    timeout = setTimeout(() => {
      applyCustomUI();
    }, 150);

  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // INITIAL RUN
  applyCustomUI();

});

// product single slider
function sliderRelatedProduct() {

  const container = document.querySelector('.swiper-recommendations');
  if (!container) return;

  // ❗ Prevent multiple initializations
  if (container.classList.contains('swiper-initialized')) return;

  const progressBar = container.querySelector('.progress');

  const swiper = new Swiper(container, {
    spaceBetween: 20,
    loop: true,
    slidesPerView: 5,
    speed: 500,

    navigation: {
    nextEl: container.closest('.related-products').querySelector('.swiper-button-next'),
    prevEl: container.closest('.related-products').querySelector('.swiper-button-prev'),
  },

    on: {
      init: function () {
        updateProgress(this);
      },
      slideChange: function () {
        updateProgress(this);
      }
    }
  });

  function updateProgress(swiper) {
    if (!progressBar) return;

    const totalSlides = swiper.slides.length - swiper.loopedSlides * 2;
    const currentSlide = swiper.realIndex;

    const progress = (currentSlide / (totalSlides - 1)) * 100;

    progressBar.style.width = progress + '%';
  }
}

window.addEventListener('load', function() {
  sliderRelatedProduct();

  setTimeout(() => {
    sliderRelatedProduct();
  }, 500);
});


document.addEventListener("DOMContentLoaded", function () {

  console.log("✅ Boost debug active");

  // WATCH ALL CLICKS
  document.addEventListener("click", function (e) {

    const target = e.target;

    if (
      target.closest("#boost-sd__button-toolbar-mobile-clear") ||
      target.closest(".boost-sd__button-clear-all-filter")
    ) {

      console.log("🟢 CLEAR BUTTON CLICKED");
      console.log("Element:", target);
      console.log("CurrentTarget:", e.currentTarget);

    }

  }, true);

  // WATCH POINTERDOWN
  document.addEventListener("pointerdown", function (e) {

    const target = e.target;

    if (
      target.closest("#boost-sd__button-toolbar-mobile-clear") ||
      target.closest(".boost-sd__button-clear-all-filter")
    ) {

      console.log("🟡 POINTERDOWN");
      console.log(target);

    }

  }, true);

  // WATCH MOUSEDOWN
  document.addEventListener("mousedown", function (e) {

    const target = e.target;

    if (
      target.closest("#boost-sd__button-toolbar-mobile-clear") ||
      target.closest(".boost-sd__button-clear-all-filter")
    ) {

      console.log("🔵 MOUSEDOWN");
      console.log(target);

    }

  }, true);

});

document.addEventListener("DOMContentLoaded", function () {
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    if (isSafari) {
        document.body.classList.add("is-safari");
    }
});

(function () {

    const hash = window.location.hash;

    if (!hash) return;

    // Remove the hash so the browser doesn't jump again
    history.replaceState(
        null,
        "",
        window.location.pathname + window.location.search
    );

    window.addEventListener("load", function () {

        const target = document.querySelector(hash);

        if (!target) return;

        setTimeout(function () {

            target.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });

            // Put the hash back (optional)
            history.replaceState(
                null,
                "",
                window.location.pathname + window.location.search + hash
            );

        }, 300);

    });

})();